import { render, staticRenderFns } from "./payDeposit.vue?vue&type=template&id=5be45166&scoped=true&"
import script from "./payDeposit.vue?vue&type=script&lang=js&"
export * from "./payDeposit.vue?vue&type=script&lang=js&"
import style0 from "./payDeposit.vue?vue&type=style&index=0&id=5be45166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be45166",
  null
  
)

export default component.exports